<template>
  <section id="content-other" class="content-other">
    <h2>Other Details</h2>

    <v-tabs
      v-model="selectedTab"
      slider-color="#606060" 
      slider-size="3"
      background-color="#E6E6E6"
    >
      <v-tab
        id="content-demographics"
        key="demographics"
        class="tab_bg_color"
        @click="$emit('update:activeSection', 'content-demographics')"
      >
        CLIENT DEMOGRAPHIC
      </v-tab>
      <v-tab
        id="content-technology"
        key="techology"
        class="tab_bg_color"
        @click="$emit('update:activeSection', 'content-technology')"
      >
        TECHNOLOGY USE
      </v-tab>
      <v-tab
        id="content-communication"
        key="communication"
        class="tab_bg_color"
        @click="$emit('update:activeSection', 'content-communication')"
      >
        COMMUNICATION METHODS
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab" class="v-tabs-items content-other pa-0 ma-0">
      <v-tab-item key="demographics" :eager="true" class="content-other demo_padding">
        <Demographics
          :clientDemographics="listing.client_demographics"
          :insuranceBasedListings="insuranceBasedListings"
          :practiceType="listing.listing_type"
        />
      </v-tab-item>
      <v-tab-item key="techology" :eager="true" class="content-other tech_padding">
        <Technology
          :technologyAggregation="listing.tech_account_aggregation"
          :technologyAccounting="listing.tech_accounting"
          :technologyCrm="listing.tech_crm"
          :technologyDocument="listing.tech_document_management"
          :technologyFinancial="listing.tech_financial_planning"
          :technologyOther="listing.tech_other"
          :technologyPortfolio="listing.tech_portfolio_rebalancing"
        />
      </v-tab-item>
      <v-tab-item key="communication" class="content-other comm_padding">
        <Communication
          :communicationMethods="listing.comm_methods"
          :meetingsAtHome="listing.comm_clients_home"
          :meetingsAtOffice="listing.comm_secondary_office"
          :meetingFrequency="listing.comm_face_meeting_frequency"
          :meetingsAtPrimaryOffice="listing.comm_face_primary_office"
          :meetingsAtSecondaryOffice="listing.comm_face_secondary_office"
          :meetingsAtClientHome="listing.comm_face_clients_home"
          :meetingsAtClientOffice="listing.comm_face_clients_office"
          :communicationsList="communicationsList"
        />
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<script>
import Communication from './section-other/Communication'
import Demographics from './section-other/Demographics'
import Technology from './section-other/Technology'

export default {
  name: 'DetailsOtherInformation',
  components: {
    Communication,
    Demographics,
    Technology,
  },
  props: {
    activeSection: String,
    communicationsList: Array,
    insuranceBasedListings: Array,
    listing: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    selectedTab: 0,
    tabs: [
      'content-demographics',
      'content-technology',
      'content-communication'
    ],
  }),

  watch: {
    activeSection (oldVal, newVal) {
      if (oldVal === newVal) return

      const tab = this.tabs.indexOf(this.activeSection)
      if (tab > -1) this.selectedTab = tab
    },
  },
}
</script>

<style scoped>
  .content-other {
    background-color: #EFEFEF !important;
  }
  .demo_padding {
    background-color: #EFEFEF;
    padding: 0;
  }
  .tech_padding {
    background-color: #EFEFEF;
    padding: 20px 0 60px 0;
  }
  .comm_padding {
    background-color: #EFEFEF;
    padding: 20px 0 60px 0;
  }

  .tab_bg_color {
    background-color: #E6E6E6;
  }
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/OtherInformation.vue